<template>
  <project-detail-layout :tab="1">
    <div class="project_detail">
      <form autocomplete="off" @submit.prevent="handleSubmit">
        <div class="project_info_wrapper">
          <div class="project_detail_form">
            <div :class="{ 'border_bottom pb_20': !project.is_spot_type }"
                 class="project_detail_name w_100">
              <div class="project_detail_input">
                <label class="project_detail_input__label">
                  {{ $t('project_management.project_detail.input_label.project_name') }}
                  <span class="required">*</span>
                </label>
                <input
                  v-model="project.name"
                  class="project_detail_input__input w_96"
                  placeholder="Nhập tên dự án"
                  type="text"/>
                <div v-for="error of $v.project.$errors" :key="error.$uid">
                  <div v-if="error.$property === 'name'" class="validation_error">
                    Tên dự án {{
                      $t('fields.project_detail.validation.' + error.$validator)
                    }}
                  </div>
                </div>
              </div>
              <div v-if="project.is_spot_type" class="project_detail_input spot_detail_input">
                <label class="project_detail_input__label">
                  {{
                    $t('project_management.project_detail.input_label.project_cost')
                  }}
                </label>
                <input
                  v-model="project.contract_value"
                  class="project_detail_input__input disabled w_96"
                  placeholder="Cost"
                  type="text">
                <div v-for="error of $v.project.$errors" :key="error.$uid">
                  <div v-if="error.$property === 'contract_value'" class="validation_error">
                    Cost {{
                      $t('fields.project_detail.validation.' + error.$validator)
                    }}
                  </div>
                </div>
              </div>
              <div v-else class="project_detail_input spot_detail_input">
                <label class="project_detail_input__label">
                  {{
                    $t('project_management.project_detail.input_label.project_cost')
                  }}
                </label>
                <input v-model="contractValue"
                       :readonly="!project.is_spot_type"
                       class="project_detail_input__input project_detail_input_labo disabled w_96"
                       type="text">
                <div v-for="error of $v.project.$errors" :key="error.$uid">
                  <div v-if="error.$property === 'contract_value'" class="validation_error">
                    Cost {{
                      $t('fields.project_detail.validation.' + error.$validator)
                    }}
                  </div>
                </div>
              </div>
              <div v-if="project.is_spot_type" class="project_detail_input">
                <b-button id="popover-target-1">
                  <svg class="spot_icon_cost" fill="none" height="20" viewBox="0 0 20 20" width="20"
                       xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_6918_18292)">
                      <path
                        d="M9.99958 0C4.47746 0 0 4.47746 0 9.99958C0 15.5217 4.47746 20 9.99958 20C15.5217 20 20 15.5217 20 9.99958C20 4.47746 15.5217 0 9.99958 0ZM12.0813 15.498C11.5666 15.7012 11.1568 15.8552 10.8495 15.9619C10.5431 16.0686 10.1867 16.1219 9.78116 16.1219C9.15809 16.1219 8.67301 15.9695 8.32762 15.6656C7.98222 15.3617 7.81037 14.9765 7.81037 14.5084C7.81037 14.3263 7.82307 14.1401 7.84846 13.9505C7.87471 13.7608 7.91619 13.5475 7.97291 13.3079L8.61714 11.0324C8.67386 10.814 8.72296 10.6066 8.7619 10.4135C8.80085 10.2188 8.81947 10.0402 8.81947 9.87767C8.81947 9.58815 8.75937 9.38497 8.64 9.27069C8.51894 9.1564 8.29122 9.10053 7.95175 9.10053C7.78582 9.10053 7.61481 9.12508 7.43958 9.17672C7.26603 9.23005 7.11534 9.27831 6.99175 9.32571L7.1619 8.62476C7.58349 8.45291 7.9873 8.30561 8.37249 8.1837C8.75767 8.06011 9.12169 7.99915 9.46455 7.99915C10.0834 7.99915 10.5608 8.14984 10.8969 8.44783C11.2313 8.74667 11.3998 9.13524 11.3998 9.6127C11.3998 9.71175 11.3879 9.88614 11.3651 10.135C11.3422 10.3848 11.299 10.6125 11.2364 10.8216L10.5956 13.0904C10.5431 13.2724 10.4965 13.4806 10.4542 13.7134C10.4127 13.9462 10.3924 14.124 10.3924 14.2434C10.3924 14.5448 10.4593 14.7505 10.5947 14.8597C10.7285 14.9689 10.963 15.0239 11.2948 15.0239C11.4514 15.0239 11.6267 14.996 11.8248 14.9418C12.0212 14.8876 12.1634 14.8394 12.2531 14.7979L12.0813 15.498ZM11.9678 6.2891C11.669 6.56677 11.3092 6.70561 10.8885 6.70561C10.4686 6.70561 10.1062 6.56677 9.80487 6.2891C9.50518 6.01143 9.35365 5.67365 9.35365 5.27915C9.35365 4.8855 9.50603 4.54688 9.80487 4.26667C10.1062 3.98561 10.4686 3.84593 10.8885 3.84593C11.3092 3.84593 11.6698 3.98561 11.9678 4.26667C12.2667 4.54688 12.4165 4.8855 12.4165 5.27915C12.4165 5.6745 12.2667 6.01143 11.9678 6.2891Z"
                        fill="#17A896"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_6918_18292">
                        <rect fill="white" height="20" width="20"/>
                      </clipPath>
                    </defs>
                  </svg>
                </b-button>
              </div>
              <div id="cost_history" class="text-center my-3" style="display: none">
                <b-popover placement="top" target="popover-target-1" triggers="hover">
                  <template #title></template>
                  <p style="width: 200px; text-align: center; font-size: 14px;line-height: 10px; margin-top: 5px">Lịch
                    sử hợp đồng</p>
                  <hr>
                  <div v-for="(contract, key) in contract_management" :key="key"
                       class="detail_history_contract"
                       style="width: 200px; border-bottom: 1px #000000">
                    <b-row>
                      <b-col style="text-align: left; line-height: 10px; color: #303C54;">{{
                          contract.effective_date
                        }}
                      </b-col>
                      <b-col style="text-align: right; line-height: 10px; font-weight: 700;color: #303C54;">
                        {{ contract.cost }}MM
                      </b-col>
                    </b-row>
                    <hr v-if="key < contract_management.length - 1">
                  </div>
                </b-popover>
              </div>
              <div v-if="!project.is_spot_type" class="project_detail_input" style="margin-right: 35px;"></div>
            </div>
            <div v-if="!project.is_spot_type" class="project_detail_labo">
              <div v-for="(payment, index) in project.project_labo_payments" :key="payment.id"
                   class="project_detail_labo__container">
                <div class="project_mm_container">
                  <div class="project_time_cost">
                    <div class="project_detail_input">
                      <label class="project_detail_input__label">
                        {{ $t('project_management.project_detail.input_label.project_start_date') }}
                        <span class="required">*</span>
                      </label>
                      <DatePicker
                        v-model="payment.start_date"
                        :clearable="false"
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        value-type="format"/>
                      <div v-for="error of $v.project.$errors" :key="error.$uid">
                        <div
                          v-if="error.$property === 'project_labo_payments' && error.$response.$errors[index].start_date.length > 0"
                          class="validation_error">
                          Thời gian bắt đầu {{
                            $t('fields.project_detail.validation.' +
                              error.$response.$errors[index].start_date[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="project_detail_input">
                      <label class="project_detail_input__label">
                        {{ $t('project_management.project_detail.input_label.project_end_date') }}
                        <span class="required">*</span>
                      </label>
                      <DatePicker
                        v-model="payment.end_date"
                        :clearable="false"
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        value-type="format"/>
                      <div v-for="error of $v.project.$errors" :key="error.$uid">
                        <div
                          v-if="error.$property === 'project_labo_payments' && error.$response.$errors[index].end_date.length > 0"
                          class="validation_error">
                          Thời gian kết thúc {{
                            $t('fields.project_detail.validation.' +
                              error.$response.$errors[index].end_date[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="project_detail_input">
                      <label class="project_detail_input__label">
                        Cost
                        <span class="required">*</span>
                      </label>
                      <input v-model="payment.cost"
                             class="project_detail_input__input"
                             oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                             placeholder="Nhập cost"
                             type="text"/>
                      <div v-for="error of $v.project.$errors" :key="error.$uid">
                        <div
                          v-if="error.$property === 'project_labo_payments' && error.$response.$errors[index].cost.length > 0"
                          class="validation_error">
                          Cost {{
                            $t('fields.project_detail.validation.' + error.$response.$errors[index].cost[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="project_employee_detail">
                    <div class="project_detail_input">
                      <label class="project_detail_input__label">
                        {{ $t('project_management.project_detail.input_label.pm') }}
                      </label>
                      <input v-model="payment.pm"
                             class="project_detail_input__input"
                             oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                             placeholder="Nhập số lượng"
                             type="text"/>
                      <div v-for="error of $v.project.$errors" :key="error.$uid">
                        <div
                          v-if="error.$property === 'pm' && error.$response.$errors[index].pm.length > 0"
                          class="validation_error">
                          PM {{
                            $t('fields.project_detail.validation.' + error.$response.$errors[index].pm[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="project_detail_input">
                      <label class="project_detail_input__label">
                        {{ $t('project_management.project_detail.input_label.brse') }}
                      </label>
                      <input v-model="payment.brse"
                             class="project_detail_input__input"
                             oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                             placeholder="Nhập số lượng"
                             type="text"/>
                      <div v-for="error of $v.project.$errors" :key="error.$uid">
                        <div
                          v-if="error.$property === 'brse' && error.$response.$errors[index].brse.length > 0"
                          class="validation_error">
                          BrSe {{
                            $t('fields.project_detail.validation.' + error.$response.$errors[index].brse[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="project_detail_input">
                      <label class="project_detail_input__label">
                        {{ $t('project_management.project_detail.input_label.developer') }}
                      </label>
                      <input v-model="payment.developer"
                             class="project_detail_input__input"
                             oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                             placeholder="Nhập số lượng"
                             type="text"/>
                      <div v-for="error of $v.project.$errors" :key="error.$uid">
                        <div
                          v-if="error.$property === 'developer' && error.$response.$errors[index].developer.length > 0"
                          class="validation_error">
                          Developer {{
                            $t('fields.project_detail.validation.' + error.$response.$errors[index].developer[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="project_detail_input">
                      <label class="project_detail_input__label">
                        {{ $t('project_management.project_detail.input_label.qa') }}
                      </label>
                      <input v-model="payment.qa"
                             class="project_detail_input__input"
                             oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                             placeholder="Nhập số lượng"
                             type="text"/>
                      <div v-for="error of $v.project.$errors" :key="error.$uid">
                        <div
                          v-if="error.$property === 'qa' && error.$response.$errors[index].qa.length > 0"
                          class="validation_error">
                          QA {{
                            $t('fields.project_detail.validation.' + error.$response.$errors[index].qa[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="project_detail_input">
                      <label class="project_detail_input__label">
                        {{ $t('project_management.project_detail.input_label.other') }}
                      </label>
                      <input v-model="payment.other"
                             class="project_detail_input__input"
                             placeholder="Nhập tên chức vụ"
                             type="text"/>
                      <div v-for="error of $v.project.$errors" :key="error.$uid">
                        <div
                          v-if="error.$property === 'other' && error.$response.$errors[index].other.length > 0"
                          class="validation_error">
                          Other {{
                            $t('fields.project_detail.validation.' + error.$response.$errors[index].other[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="project_detail_input">
                      <label class="project_detail_input__label none_label">
                      </label>
                      <input v-model="payment.other_number"
                             class="project_detail_input__input"
                             oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                             placeholder="Nhập số lượng"/>
                      <div v-for="error of $v.project.$errors" :key="error.$uid">
                        <div
                          v-if="error.$property === 'other_number' && error.$response.$errors[index].other_number.length > 0"
                          class="validation_error">
                          Other {{
                            $t('fields.project_detail.validation.' + error.$response.$errors[index].other_number[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <img alt="" class="project_detail_labo_icon_del" src="@/assets/icons/trash.svg"
                     @click="deleteLaboPayment(index)">
              </div>
              <div class="btn_add_wrapper">
                <img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addLaboPayment"/>
                <h3 class="btn_add__title" @click="addLaboPayment">{{
                    $t('project_management.project_detail.button_title.add_payment')
                  }}</h3>
              </div>
            </div>
            <div v-if="project.is_spot_type" class="project_detail_input">
            </div>
          </div>
        </div>
        <div class="project_customer_wrapper">
          <div class="project_detail_catalog">
            <h3 class="project_detail_catalog__name">{{
                $t('project_management.project_detail.catalog_name.customer')
              }}</h3>
          </div>
          <div class="project_detail_form">
            <div class="project_detail_input">
              <label class="project_detail_input__label">
                {{ $t('project_management.project_detail.input_label.customer_name') }}
                <span class="required">*</span>
              </label>
              <Select2 :id="project.customer_id" v-model="project.customer_id" :options="customerList"
                       placeholder="Lựa chọn"/>
              <div v-for="error of $v.project.$errors" :key="error.$uid">
                <div v-if="error.$property === 'customer_id'" class="validation_error">
                  Tên khách hàng {{
                    $t('fields.project_detail.validation.' + error.$validator)
                  }}
                </div>
              </div>
            </div>
            <div class="project_detail_input">
              <label class="project_detail_input__label">
                {{ $t('project_management.project_detail.input_label.customer_top') }}
                <span class="required">*</span>
              </label>
              <input v-model="project.customer_info.customer_manager" class="project_detail_input__input"
                     name="project_management.project" type="text">
              <div v-for="error of $v.project.$errors" :key="error.$uid">
                <div v-if="error.$property === 'customer_manager'" class="validation_error">
                  Top khách hàng {{
                    $t('fields.project_detail.validation.' + error.$validator)
                  }}
                </div>
              </div>
            </div>
            <div class="project_detail_input">
              <label class="project_detail_input__label">
                {{ $t('project_management.project_detail.input_label.customer_pm') }}
                <span class="required">*</span>
              </label>
              <input v-model="project.customer_info.customer_project_manager" class="project_detail_input__input"
                     type="text">
              <div v-for="error of $v.project.$errors" :key="error.$uid">
                <div v-if="error.$property === 'customer_project_manager'" class="validation_error">
                  PM khách hàng {{
                    $t('fields.project_detail.validation.' + error.$validator)
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project_fabbi_jp_wrapper">
          <div class="project_detail_catalog">
            <h3 class="project_detail_catalog__name">{{
                $t('project_management.project_detail.catalog_name.fabbi_jp')
              }}</h3>
          </div>
          <div class="project_detail_form">
            <div class="project_detail_input">
              <label class="project_detail_input__label">
                {{ $t('project_management.project_detail.input_label.jp_top') }}
                <span class="required">*</span>
              </label>
              <input v-model="project.customer_info.top_japan_fabbi" class="project_detail_input__input"
                     type="text">
              <div v-for="error of $v.project.$errors" :key="error.$uid">
                <div v-if="error.$property === 'top_japan_fabbi'" class="validation_error">
                  TopFJ {{
                    $t('fields.project_detail.validation.' + error.$validator)
                  }}
                </div>
              </div>
            </div>
            <div class="project_detail_input">
              <label class="project_detail_input__label">
                {{ $t('project_management.project_detail.input_label.jp_tech') }}
                <span class="required">*</span>
              </label>
              <input v-model="project.customer_info.fabbi_japan_tech" class="project_detail_input__input"
                     name="jp_tech" type="text">
              <div v-for="error of $v.project.$errors" :key="error.$uid">
                <div v-if="error.$property === 'fabbi_japan_tech'" class="validation_error">
                  Tech {{
                    $t('fields.project_detail.validation.' + error.$validator)
                  }}
                </div>
              </div>
            </div>
            <div class="project_detail_input">
              <label class="project_detail_input__label" for="jp_sale">
                {{ $t('project_management.project_detail.input_label.jp_sale') }}
                <span class="required">*</span>
              </label>
              <input v-model="project.customer_info.fabbi_japan_sale" class="project_detail_input__input"
                     name="jp_tech" type="text">
              <div v-for="error of $v.project.$errors" :key="error.$uid">
                <div v-if="error.$property === 'fabbi_japan_sale'" class="validation_error">
                  Sale {{
                    $t('fields.project_detail.validation.' + error.$validator)
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="project.is_spot_type" class="project_plan_wrapper">
          <div class="project_detail_catalog">
            <h3 class="project_detail_catalog__name">{{
                $t('project_management.project_detail.catalog_name.plan')
              }}</h3>
          </div>
          <div class="ptable_wrapper">
            <table class="table ptable">
              <thead class="ptable__thead">
              <tr>
                <th class="vertical_align" scope="col">{{
                    $t('project_management.project_detail.table_column.pound')
                  }}
                </th>
                <th class="vertical_align" scope="col">{{
                    $t('project_management.project_detail.table_column.task')
                  }}
                </th>
                <th class="vertical_align" scope="col">{{
                    $t('project_management.project_detail.table_column.assign')
                  }}
                </th>
                <th class="vertical_align" scope="col">
                  {{ $t('project_management.project_detail.table_column.start_date') }}
                </th>
                <th class="vertical_align" scope="col">{{
                    $t('project_management.project_detail.table_column.end_date')
                  }}
                </th>
                <th v-for="(date, index) in dateRange" :key="index" scope="col">{{
                    getDatePlanColumnFormat(date)
                  }}
                </th>
                <th class="vertical_align" scope="col"></th>
              </tr>
              </thead>
              <tbody class="ptable__tbody">
              <tr v-for="(plan, index) in project.plans" :key="plan.id">
                <th class="text-center" scope="row">{{ index + 1 }}</th>
                <td>
                  <div class="ptable_input_wrapper">
                    <input v-model="plan.plan_name"
                           :class="[ plan.is_edit_plan_name ? 'ptable__input' : '' ]"
                           class="editabled ptable__plan_name"
                           type="text"/>
                    <img v-if="plan.is_edit_plan_name" class="ptable__icon"
                         src="@/assets/icons/icon_x.svg"
                         @click="onEditabled(project.plans, index ,'is_edit_plan_name')"
                    />
                    <img v-else class="ptable__icon"
                         src="@/assets/icons/icon_pencil.svg"
                         @click="onEditabled(project.plans, index ,'is_edit_plan_name')"
                    />
                    <div v-for="error of $v.project.plans.$errors" :key="error.$uid">
                      <div v-if="error.$property === 'plans' && error.$response.$errors.length > 0">
                        <div v-if="error.$response.$errors[index].plan_name.length > 0" class="validation_error">
                          Task {{
                            $t('fields.project_detail.validation.' +
                              error.$response.$errors[index].plan_name[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="ptable_input_wrapper">
                    <input v-model="plan.assign"
                           :class="[ plan.is_edit_assign ? 'ptable__input' : '' ]"
                           class="editabled"
                           type="text"/>
                    <img v-if="plan.is_edit_assign"
                         class="ptable__icon"
                         src="@/assets/icons/icon_x.svg"
                         @click="onEditabled(project.plans, index ,'is_edit_assign')"/>
                    <img v-else
                         class="ptable__icon"
                         src="@/assets/icons/icon_pencil.svg"
                         @click="onEditabled(project.plans, index ,'is_edit_assign')"/>
                    <div v-for="error of $v.project.plans.$errors" :key="error.$uid">
                      <div v-if="error.$property === 'plans' && error.$response.$errors.length > 0">
                        <div v-if="error.$response.$errors[index].assign.length > 0" class="validation_error">
                          Assign {{
                            $t(
                              'fields.project_detail.validation.' + error.$response.$errors[index].assign[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="ptable_input_wrapper">
                    <DatePicker
                      v-model="plan.start_date"
                      :clearable="false"
                      format="DD/MM/YYYY"
                      placeholder="DD/MM/YYYY"
                      value-type="format"
                      @change="handleChangePlanDate"/>
                    <div v-for="error of $v.project.plans.$errors" :key="error.$uid">
                      <div v-if="error.$property === 'plans' && error.$response.$errors.length > 0">
                        <div v-if="error.$response.$errors[index].start_date.length > 0" class="validation_error">
                          Thời gian bắt đầu {{
                            $t('fields.project_detail.validation.' +
                              error.$response.$errors[index].start_date[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="ptable_input_wrapper">
                    <DatePicker
                      v-model="plan.end_date"
                      :clearable="false"
                      format="DD/MM/YYYY"
                      placeholder="DD/MM/YYYY"
                      value-type="format"
                      @change="handleChangePlanDate"/>
                    <div v-for="error of $v.project.plans.$errors" :key="error.$uid">
                      <div v-if="error.$property === 'plans' && error.$response.$errors.length > 0">
                        <div v-if="error.$response.$errors[index].end_date.length > 0" class="validation_error">
                          Thời gian kết thúc {{
                            $t('fields.project_detail.validation.' +
                              error.$response.$errors[index].end_date[0].$validator)
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td v-for="(date, ind) in dateRange" :key="ind"
                    :class="[ handleFillColor(plan.start_date, date, index, plan) || handleFillColor(plan.end_date, date, index, plan) || handleFillColor(null, date, index, plan)]">
                  <img v-if="handleShowStar(plan.end_date, date)" class="ptable__icon"
                       src="@/assets/icons/icon_start.svg"/>
                </td>
                <td class="vertical_align">
                  <div v-if="index > 0" class="btn_add_wrapper" @click="removePlan(index)">
                    <img class="plus_icon" src="@/assets/icons/trash.svg"/>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="btn_add_wrapper">
              <img class="plus_icon" src="@/assets/icons/icon_plus.svg" @click="addPlan"/>
              <h3 class="btn_add__title" @click="addPlan">{{
                  $t('project_management.project_detail.button_title.add_plan')
                }}</h3>
            </div>
          </div>
        </div>
        <div class="project_employee_wrapper">
          <div class="project_detail_catalog">
            <h3 class="project_detail_catalog__name">{{
                $t('project_management.project_detail.catalog_name.project_info')
              }}</h3>
          </div>
          <div class="project_detail_form_wrapper">
            <div class="project_detail_form project_info">
              <div class="project_detail_input">
                <label class="project_detail_input__label">
                  {{ $t('project_management.project_detail.input_label.link_document') }}
                </label>
                <input
                  v-if="project.project_info_detail"
                  v-model="project.project_info_detail.document_link"
                  class="project_detail_input__input"
                  placeholder="Nhập link tài liệu"
                  type="text">
                <div v-for="error of $v.project.$errors" :key="error.$uid">
                  <div v-if="error.$property === 'document_link'" class="validation_error">
                    Link tài liệu {{
                      $t('fields.project_detail.validation.' + error.$validator)
                    }}
                  </div>
                </div>
              </div>
              <div class="project_detail_input">
                <label class="project_detail_input__label" for="project_name">
                  {{ $t('project_management.project_detail.input_label.technology') }}
                  <span class="required">*</span>
                </label>
                <multiselect
                  v-if="project.project_info_detail"
                  v-model="project.project_info_detail.technology_list"
                  :close-on-select="false"
                  :multiple="true"
                  :options="project.technologies"
                  :preserve-search="false"
                  deselectLabel=""
                  label="name"
                  placeholder="Lựa chọn"
                  selectLabel=""
                  selectedLabel=""
                  track-by="name"
                >
                  <template slot="selection" slot-scope="props">
                                    <span v-if="props.length">
                                      <span v-for="(value, index) in props" :key="index" class="multiselect__single">
                                        <span class="option__title">
                                        {{ value.name }}
                                        </span>
                                      </span>
                                    </span>
                  </template>
                  <template slot="option" slot-scope="props">
                    <input :checked="isTechnologySelected(props.option.id)" type="checkbox"/>
                    <span class="option__title">
                                    {{ props.option.name }}
                                  </span>
                  </template>
                </multiselect>
                <div v-for="error of $v.project.$errors" :key="error.$uid">
                  <div v-if="error.$property === 'technology_list'" class="validation_error">
                    Công nghệ {{
                      $t("fields.project_detail.validation." + error.$validator)
                    }}
                  </div>
                </div>
              </div>
              <div class="project_detail_input">
                <label class="project_detail_input__label">
                  {{ $t('project_management.project_detail.input_label.domain') }}
                  <span v-if="project.is_spot_type" class="required">*</span>
                </label>
                <input
                  v-model="project.project_info_detail.domain"
                  class="project_detail_input__input"
                  placeholder="Nhập domain"
                  type="text">
                <div v-for="error of $v.project.$errors" :key="error.$uid">
                  <div v-if="error.$property === 'domain'" class="validation_error">
                    Domain {{
                      $t("fields.project_detail.validation." + error.$validator)
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="project_detail_form project_info">
              <div class="project_detail_input">
                <label class="project_detail_input__label">
                  {{ $t('project_management.project_detail.input_label.fes_url') }}
                </label>
                <input
                  v-model.trim="project.project_info_detail.fes_url"
                  class="project_detail_input__input"
                  placeholder="Nhập link fes"
                  style="width: 32.4%;"
                  type="text">
                <div v-for="error of $v.project.$errors" :key="error.$uid">
                  <div v-if="error.$property === 'fes_url'" class="validation_error">
                    {{ $t('project_management.project_detail.input_label.fes_url') }} {{
                      $t("fields.project_detail.validation." + error.$validator)
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="project_detail_form project_info">
              <div class="project_detail_input">
                <label class="project_detail_input__label">
                  {{ $t('project_management.project_detail.input_label.backlog_project_key') }}
                </label>
                <input
                  v-model="project.project_info_detail.backlog_project_key"
                  class="project_detail_input__input"
                  placeholder="Nhập Project Backlog Key"
                  style="width: 32.4%;"
                  type="text">
                <div v-for="error of $v.project.$errors" :key="error.$uid">
                  <div v-if="error.$property === 'backlog_project_key'" class="validation_error">
                    {{ $t('project_management.project_detail.input_label.backlog_project_key') }} {{ $t('fields.project_detail.validation.' + error.$validator) }}
                  </div>
                </div>
                <div v-if="serverErrors.backlog_project_key" class="validation_error">
                  {{ serverErrors.backlog_project_key }}
                </div>
              </div>
            </div>
            <div v-if="project.is_spot_type" class="btn_add_wrapper project_img_wrapper">
              <label class="project_detail_input__label">
                {{ $t('project_management.project_detail.input_label.project_img') }}
                <span class="required">*</span>
              </label>
              <button class="pro_info_add_image" type="button" @click="uploadImage()">
                <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_7063_358)">
                    <path
                      d="M10.4621 3.11784H3.62012V1.16922C3.62012 0.523451 4.14357 0 4.78929 0H9.29286C9.93859 0 10.4621 0.523451 10.4621 1.16922V3.11784Z"
                      fill="url(#paint0_linear_7063_358)"/>
                    <path
                      d="M8.70406 3.11784H1.86206V1.16922C1.86206 0.523451 2.38555 0 3.03128 0H7.53485C8.18057 0 8.70406 0.523451 8.70406 1.16922V3.11784Z"
                      fill="url(#paint1_linear_7063_358)"/>
                    <path
                      d="M6.84196 2.21929V1.16922C6.84196 0.523451 6.31851 0 5.67278 0H1.16922C0.523451 0 0 0.523451 0 1.16922V13.7937C0 14.7136 0.745765 15.4594 1.66569 15.4594H18.3343C19.2542 15.4594 20 14.7136 20 13.7937V4.3938C20 3.47388 19.2542 2.72812 18.3343 2.72812H7.35078C7.06977 2.72812 6.84196 2.50031 6.84196 2.21929V2.21929Z"
                      fill="url(#paint2_linear_7063_358)"/>
                    <path
                      d="M15.1889 5.01947H14.7878C14.5577 5.01947 14.3712 4.83296 14.3712 4.60288V4.20174C14.3712 3.97167 14.5577 3.78516 14.7878 3.78516H15.1889C15.419 3.78516 15.6055 3.97167 15.6055 4.20174V4.60288C15.6055 4.83296 15.419 5.01947 15.1889 5.01947Z"
                      fill="url(#paint3_linear_7063_358)"/>
                    <path
                      d="M16.7627 5.01947H16.3615C16.1315 5.01947 15.9449 4.83296 15.9449 4.60288V4.20174C15.9449 3.97167 16.1315 3.78516 16.3615 3.78516H16.7627C16.9927 3.78516 17.1793 3.97167 17.1793 4.20174V4.60288C17.1793 4.83296 16.9927 5.01947 16.7627 5.01947Z"
                      fill="url(#paint4_linear_7063_358)"/>
                    <path
                      d="M18.3365 5.01947H17.9354C17.7053 5.01947 17.5188 4.83296 17.5188 4.60288V4.20174C17.5188 3.97167 17.7053 3.78516 17.9354 3.78516H18.3365C18.5666 3.78516 18.7531 3.97167 18.7531 4.20174V4.60288C18.7531 4.83296 18.5666 5.01947 18.3365 5.01947Z"
                      fill="url(#paint5_linear_7063_358)"/>
                    <path
                      d="M0 11.9521V13.7941C0 14.714 0.745765 15.4598 1.66569 15.4598H18.3343C19.2542 15.4598 20 14.714 20 13.7941V11.9521H0Z"
                      fill="url(#paint6_linear_7063_358)"/>
                    <path
                      d="M19.1557 15.2429L10.8717 7.11583C10.3493 6.43712 9.52526 6.47061 9.05686 7.21747L5.09926 13.5901C4.73271 14.1745 4.83933 14.8418 5.32149 15.2126C5.38733 15.2981 5.59973 15.4536 5.60455 15.4596H18.3344C18.6331 15.4596 18.9133 15.3806 19.1557 15.2429V15.2429Z"
                      fill="url(#paint7_linear_7063_358)"/>
                    <path
                      d="M13.9968 15.468H12.8344V19.0094C12.8344 19.5563 12.391 19.9997 11.8441 19.9997H8.38936C7.84242 19.9997 7.39901 19.5563 7.39901 19.0094V15.468H6.00309C5.01862 15.468 4.41909 14.3844 4.94219 13.5504L8.93905 7.17773C9.42987 6.39518 10.57 6.39518 11.0609 7.17773L15.0577 13.5504C15.5808 14.3844 14.9813 15.468 13.9968 15.468Z"
                      fill="url(#paint8_linear_7063_358)"/>
                    <path
                      d="M13.9969 15.468H12.8345V19.0094C12.8345 19.5563 12.3911 19.9997 11.8441 19.9997H10V6.59082C10.4078 6.59082 10.8155 6.78647 11.0609 7.17772L15.0578 13.5503C15.5809 14.3843 14.9813 15.468 13.9969 15.468Z"
                      fill="url(#paint9_linear_7063_358)"/>
                  </g>
                  <defs>
                    <linearGradient id="paint0_linear_7063_358" gradientUnits="userSpaceOnUse" x1="7.0411" x2="7.0411"
                                    y1="0.649569"
                                    y2="3.11937">
                      <stop stop-color="#FF9100"/>
                      <stop offset="1" stop-color="#E63950"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear_7063_358" gradientUnits="userSpaceOnUse" x1="5.28308" x2="5.28308"
                                    y1="0.649569"
                                    y2="3.11937">
                      <stop stop-color="#FDBF00"/>
                      <stop offset="1" stop-color="#FF9100"/>
                    </linearGradient>
                    <linearGradient id="paint2_linear_7063_358" gradientUnits="userSpaceOnUse" x1="2.27902" x2="13.9641"
                                    y1="1.37275"
                                    y2="13.0579">
                      <stop stop-color="#FFDA2D"/>
                      <stop offset="1" stop-color="#FDBF00"/>
                    </linearGradient>
                    <linearGradient id="paint3_linear_7063_358" gradientUnits="userSpaceOnUse" x1="14.8513" x2="15.4152"
                                    y1="4.29782"
                                    y2="4.72751">
                      <stop stop-color="#76E2F8"/>
                      <stop offset="1" stop-color="#48B2E3"/>
                    </linearGradient>
                    <linearGradient id="paint4_linear_7063_358" gradientUnits="userSpaceOnUse" x1="16.425" x2="16.9889"
                                    y1="4.29782"
                                    y2="4.72751">
                      <stop stop-color="#76E2F8"/>
                      <stop offset="1" stop-color="#48B2E3"/>
                    </linearGradient>
                    <linearGradient id="paint5_linear_7063_358" gradientUnits="userSpaceOnUse" x1="17.9988" x2="18.5628"
                                    y1="4.29782"
                                    y2="4.72751">
                      <stop stop-color="#76E2F8"/>
                      <stop offset="1" stop-color="#48B2E3"/>
                    </linearGradient>
                    <linearGradient id="paint6_linear_7063_358" gradientUnits="userSpaceOnUse" x1="10" x2="10"
                                    y1="13.4245"
                                    y2="16.6734">
                      <stop stop-color="#FF9100" stop-opacity="0"/>
                      <stop offset="1" stop-color="#FF9100"/>
                    </linearGradient>
                    <linearGradient id="paint7_linear_7063_358" gradientUnits="userSpaceOnUse" x1="19.257" x2="8.35471"
                                    y1="11.0453"
                                    y2="11.0453">
                      <stop stop-color="#FF9100" stop-opacity="0"/>
                      <stop offset="1" stop-color="#FF9100"/>
                    </linearGradient>
                    <linearGradient id="paint8_linear_7063_358" gradientUnits="userSpaceOnUse" x1="7.11426" x2="17.9974"
                                    y1="11.16"
                                    y2="22.0431">
                      <stop stop-color="#B9DD39"/>
                      <stop offset="1" stop-color="#0B799D"/>
                    </linearGradient>
                    <linearGradient id="paint9_linear_7063_358" gradientUnits="userSpaceOnUse" x1="10.7607"
                                    x2="-3.51377" y1="13.6922"
                                    y2="3.57455">
                      <stop stop-color="#0B799D" stop-opacity="0"/>
                      <stop offset="0.3645" stop-color="#096380" stop-opacity="0.365"/>
                      <stop offset="0.76" stop-color="#084F67" stop-opacity="0.76"/>
                      <stop offset="1" stop-color="#07485E"/>
                    </linearGradient>
                    <clipPath id="clip0_7063_358">
                      <rect fill="white" height="20" width="20"/>
                    </clipPath>
                  </defs>
                </svg>
                <input id="project_image" class="pro_info_image_upload" style="display: none" type="file"
                       @change="setListImage($event)">
                <input class="pro_info_image_upload" hidden>
                <h3 class="btn_add__title">Chọn ảnh</h3>
              </button>
              <div class="upload-image-list">
                <div
                  v-for="(item, key) of project.project_info_detail_images"
                  :key="'file upload' + key"
                  class="file"
                >
                  <figure>
                    <img
                      :src="item.file_url"
                    />
                  </figure>
                  <button
                    class="btn-delete"
                    type="button"
                    @click="removeOldImage(item.id, key)"
                  >
                    {{ $t('project_management.kickoff.kickoff_remove_image_button_text') }}
                  </button>
                </div>
                <div
                  v-for="(item, key) of project_info_images"
                  :key="'file upload' + key"
                  class="file"
                >
                  <figure>
                    <img
                      :src="item.file_url"
                    />
                  </figure>
                  <button
                    class="btn-delete"
                    type="button"
                    @click="removeImage(key)"
                  >
                    {{ $t('project_management.kickoff.kickoff_remove_image_button_text') }}
                  </button>
                </div>
              </div>
              <div v-if="image_error" class="validation_error">
                {{
                  this.image_error
                }}
              </div>
              <div v-for="error of $v.project.$errors" :key="error.$uid">
                <div v-if="error.$property === 'project_info_detail_images'" class="validation_error">
                  Hình ảnh {{
                    $t('fields.project_detail.validation.' + error.$validator)
                  }}
                </div>
              </div>
            </div>
            <div class="project_detail_form project_info">
              <div class="project_detail_input">
                <label class="project_detail_input__label">
                  {{ $t('project_management.project_detail.input_label.description') }}
                  <span v-if="project.is_spot_type" class="required">*</span>
                </label>
                <textarea
                  v-model="project.description"
                  class="project_detail_textarea"
                  placeholder="Nhập mô tả"></textarea>
                <div v-for="error of $v.project.$errors" :key="error.$uid">
                  <div v-if="error.$property === 'description'" class="validation_error">
                    Mô tả tổng quan {{
                      $t('fields.project_detail.validation.' + error.$validator)
                    }}
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="btn_wrapper">
            <button class="btn_submit" type="submit">
              {{ $t('project_management.project_detail.button_title.submit') }}
            </button>
            <button class="btn_cancel" type="button" @click="onBack">
              {{ $t('project_management.project_detail.button_title.cancel') }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </project-detail-layout>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import Select2 from 'v-select2-component';
import ProjectDetailLayout from './ProjectDetailLayout.vue';
import {mapActions, mapGetters} from 'vuex';
import useVuelidate from '@vuelidate/core';
import {helpers, maxLength, numeric, required, url} from '@vuelidate/validators';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'ProjectDetail',
  setup() {
    return {
      $v: useVuelidate(),
    };
  },
  data() {
    return {
      project: {
        name: '',
        customer_id: '',
        project_type: '',
        contract_value: null,
        cost: 0,
        start_date: new Date(),
        end_date: new Date(),
        plans: [
          {
            id: '',
            plan_name: '',
            assign: '',
            start_date: null,
            end_date: null,
            is_edit_plan_name: true,
            is_edit_assign: true,
            is_edit_start_date: true,
            is_edit_end_date: true,
          },
        ],
        project_labo_payments: [
          {
            cost: null,
            project_id: this.id,
            start_date: null,
            end_date: null,
            pm: null,
            dev: null,
            brse: null,
            developer: null,
            qa: null,
            other: null,
            other_number: null,
          },
        ],
        customer_info: {
          id: null,
          customer_manager: '',
          customer_project_manager: '',
          fabbi_japan_sale: '',
          fabbi_japan_tech: '',
          top_japan_fabbi: '',
        },
        payment_histories: [
          {
            time: 1,
            expected_payment_percentage: '',
            expected_payment_date: null,
            realistic_payment_percentage: '',
            realistic_payment_date: null,
          }],
        technologies: [],
        project_info_detail: {
          technology_list: [],
          document_link: '',
          domain: '',
          fes_url: '',
          backlog_project_key: ''
        },
        description: null,
        project_info_detail_images: [],
      },
      dateRange: [],
      oddClass: 'odd',
      evenClass: 'even',
      messages: {
        required: '{attribute} là bắt buộc',
        before_or_equal: 'Thời gian bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc',
      },
      defaultDateValue: new Date(),
      selectedEmployees: [],
      historyContract: [
        {
          date: '10/10/20222',
          mm: 10,
        },
        {
          date: '10/10/20222',
          mm: 10,
        },
      ],
      image_error: '',
      serverErrors: {
        backlog_project_key: ''
      },
      project_info_images: [],
      project_info_detail_images_remove: []
    };
  },
  components: {
    DatePicker,
    Select2,
    ProjectDetailLayout,
    // Input,
    Multiselect,
  },
  computed: {
    ...mapGetters({
      projectDetail: 'projectManagement/project',
      employeeList: 'projectManagement/employees',
      positionList: 'projectManagement/positions',
      customerList: 'projectManagement/customers',
      contract_management: "projectManagement/contract_management",
    }),
    contractValue() {
      let total = 0;
      if (this.project.project_labo_payments.length > 0) {
        this.project.project_labo_payments.forEach(payment => {
          if (payment.cost !== null && !Number.isNaN(payment.cost)) {
            total += payment.cost;
          }
        });
        // this.project.contract_value = total;
      }
      return Math.round(total * 100) / 100;
    },
    id() {
      return this.$route.params.id;
    },

  },
  validations() {
    if (this.project.is_spot_type) {
      return {
        project: {
          name: {
            required,
            maxLength: maxLength(255),
          },
          customer_id: {
            required,
            numeric,
          },
          project_type: {
            required,
          },
          contract_value: {
            required,
            numeric,
          },
          plans: {
            required,
            $each: helpers.forEach({
              plan_name: {
                required,
                maxLength: maxLength(255),
              },
              assign: {
                required,
                maxLength: maxLength(255),
              },
              start_date: {
                required,
                date_equal_or_before(value, object) {
                  return moment(value, 'DD/MM/YYYY').isSameOrBefore(moment(object.end_date, 'DD/MM/YYYY'));
                },
              },
              end_date: {
                required,
              },
            }),
          },
          customer_info: {
            customer_manager: {
              required,
              maxLength: maxLength(255),
            },
            customer_project_manager: {
              required,
              maxLength: maxLength(255),
            },
            fabbi_japan_sale: {
              required,
              maxLength: maxLength(255),
            },
            fabbi_japan_tech: {
              required,
              maxLength: maxLength(255),
            },
            top_japan_fabbi: {
              required,
              maxLength: maxLength(255),
            },
          },
          project_info_detail: {
            technology_list: {
              required,
            },
            // document_link: {
            //   url
            // },
            domain: {
              required,
            },
            fes_url: {
              url
            }
            ,
            backlog_project_key: {
              maxLength: maxLength(50)
            }
          },
          description: {
            required,
          },
        },
      };
    } else {
      return {
        project: {
          name: {
            required,
            maxLength: maxLength(255),
          },
          customer_id: {
            required,
          },
          project_type: {
            required,
          },
          contract_value: {
            required,
            numeric,
          },
          customer_info: {
            customer_manager: {
              required,
              maxLength: maxLength(255),
            },
            customer_project_manager: {
              required,
              maxLength: maxLength(255),
            },
            fabbi_japan_sale: {
              required,
              maxLength: maxLength(255),
            },
            fabbi_japan_tech: {
              required,
              maxLength: maxLength(255),
            },
            top_japan_fabbi: {
              required,
              maxLength: maxLength(255),
            },
          },
          project_labo_payments: {
            $each: helpers.forEach({
              cost: {
                required,
                numeric,
              },
              start_date: {
                required,
                date_equal_or_before(value, object) {
                  return moment(value, 'DD/MM/YYYY').isSameOrBefore(moment(object.end_date, 'DD/MM/YYYY'));
                },
                date_equal_or_after(value, object, index) {
                  if (this.project.project_labo_payments[index - 1] !== undefined) {
                    return moment(this.project.project_labo_payments[index - 1].end_date, 'DD/MM/YYYY').isSameOrBefore(moment(value, 'DD/MM/YYYY'));
                  } else {
                    return true;
                  }
                },
              },
              end_date: {
                required,
              },
              dev: {
                numeric,
              },
              brse: {
                numeric,
              },
              developer: {
                numeric,
              },
              qa: {
                numeric,
              },
              other: {},
              other_number: {
                numeric
              }
            }),
          },
          project_info_detail: {
            technology_list: {
              required,
            },
            // document_link: {
            //   url
            // },
            domain: {},
            fes_url: {
              url
            }
            ,
            backlog_project_key: {
              maxLength: maxLength(50)
            }
          },
          description: {},
        },
      };
    }
  },
  created() {
    this.$root.$loading.start();
    this.initial();
    setTimeout(() => this.$root.$loading.finish(), 500);
  },
  methods: {
    ...mapActions('layout', ['setLoading']),
    async handleSubmit() {
      try {
        this.$v.$touch();
        if (this.$v.$error) {
          if (this.project.is_spot_type && this.project.project_info_detail_images.length + this.project_info_images.length === 0) {
            this.image_error = 'Hình ảnh là bắt buộc'
          }
          return;
        } else {
          if (this.project.is_spot_type && this.project.project_info_detail_images.length + this.project_info_images.length === 0) {
            this.image_error = 'Hình ảnh là bắt buộc'
            return;
          }
        }
        // clear server-side errors
        this.serverErrors.backlog_project_key = '';
        this.$root.$loading.start();
        let params = new FormData();
        let contract_value = this.project.contract_value;
        if (this.project.is_spot_type && this.contract_management) {
          this.contract_management.map(function (item) {
            contract_value -= item.cost;
          });
        }
        params.append('contract_value', contract_value);
        params.append('customer_id', this.project.customer_id);
        params.append('customer_info', JSON.stringify(this.project.customer_info));
        params.append('description', this.project.description);
        params.append('end_date', this.project.end_date);
        params.append('is_spot_type', this.project.is_spot_type);
        params.append('name', this.project.name);
        params.append('plans', JSON.stringify(this.project.plans));
        params.append('pm', this.project.pm);
        params.append('project_info_detail', JSON.stringify(this.project.project_info_detail));
        params.append('project_labo_payments', JSON.stringify(this.project.project_labo_payments));
        params.append('project_info_detail_images_remove', JSON.stringify(this.project_info_detail_images_remove));
        params.append('project_type', this.project.project_type);
        params.append('start_date', this.project.start_date);
        for (let i = 0; i < this.project_info_images.length; i++) {
          let image = this.project_info_images[i];
          params.append('project_info_detail_images[' + i + ']', image);

        }
        const response = await this.$store.dispatch('projectManagement/updateProjectDetail', {
          data: params,
          id: this.id,
        });
        if (response.status === 200) {
          let message = this.$t('additional_timeSheet.message_update_success');
          this.$toast(message, 'Thông báo', 2000, 'b-toaster-top-center', 'success');
          this.$router.push({name: 'ProjectManagement'});
        }
        this.$root.$loading.finish()
      } catch (e) {
        console.error(e);
        if (e && e.response && e.response.data && e.response.data.error) {
          const err = e.response.data.error;
          if (err.code === 4220 || err.code === 4221 || err.message === 'BACKLOG_PROJECT_KEY_IS_INVALID') {
            this.serverErrors.backlog_project_key = this.$t('project_management.project_detail.validation.backlog_project_key_invalid');
            this.$root.$loading.finish();
            return;
          }
        }
        let message = this.$t('additional_timeSheet.message_update_failed');
        this.$toast(message, 'Thông báo', 2000, 'b-toaster-top-center', 'danger');
        this.$root.$loading.finish();
      }
    },
    getDateRange() {
      this.project.plans.forEach(plan => {
        this.dateRange.push([plan.start_date, plan.end_date]);
      });
      this.dateRange = this.dateRange.concat.apply([], this.dateRange).filter((value, index, self) => {
        return self.indexOf(value) === index && value !== null;
      });
      this.dateRange = this.dateRange.sort((a, b) => {
        return this.convertDateFormat(a).getTime() - this.convertDateFormat(b).getTime();
      });
    },
    getDatePlanColumnFormat(date) {
      let dateComponents = this.convertDateFormat(date);
      let month = dateComponents.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let day = dateComponents.getDate();
      day = day < 10 ? '0' + day : day;
      return month + '/' + day;
    },
    handleShowStar(planEndDate, date) {
      return this.convertDateFormat(planEndDate).getTime() === this.convertDateFormat(date).getTime();
    },
    handleFillColor(planDate = null, date, index, plan) {
      let startDate = this.convertDateFormat(plan.start_date).getTime();
      let endDate = this.convertDateFormat(plan.end_date).getTime();
      if (planDate && this.convertDateFormat(planDate).getTime() === this.convertDateFormat(date).getTime()) {
        if (index % 2 === 0) {
          return this.evenClass;
        }
        return this.oddClass;
      } else if (this.convertDateFormat(date).getTime() > startDate && this.convertDateFormat(date).getTime() <
        endDate) {
        if (index % 2 === 0) {
          return this.evenClass;
        }
        return this.oddClass;
      }
      return '';
    },
    handleChangePlanDate() {
      this.dateRange = [];
      this.getDateRange();
    },
    convertDateFormat(date) {
      return moment(date, 'DD/MM/YYYY').toDate();
    },
    onBack() {
      this.$router.push({name: 'ProjectManagement'});
    },
    addPlan() {
      this.project.plans.push({
        plan_name: '',
        assign: '',
        start_date: null,
        end_date: null,
        project_id: this.id,
        deliver_date: null,
        release_date: null,
        type: null,
        is_edit_plan_name: true,
        is_edit_assign: true,
        is_edit_start_date: true,
        is_edit_end_date: true,
      });
    },
    addLaboPayment() {
      this.project.project_labo_payments.push({
        cost: null,
        start_date: null,
        end_date: null,
        dev: null,
        brse: null,
        developer: null,
        qa: null,
        other: null,
        other_number: null,
      });
    },
    deleteLaboPayment(index) {
      this.project.project_labo_payments.splice(index, 1);
    },
    removePlan(index) {
      this.project.plans.splice(index, 1);
    },
    removePayment(index) {
      this.project.payment_histories.splice(index, 1);
    },
    onEditabled(array, index, key) {
      array[index][key] = !array[index][key];
    },
    onEditing(array, index, key) {
      array[index][key] = !array[index][key];
    },
    getDefaultProject() {
      this.project = {
        name: this.projectDetail.name,
        customer_id: this.projectDetail.customer_id,
        contract_value: this.projectDetail.is_spot_type ? Math.round(this.projectDetail.contract_value * 100) / 100 : this.contractValue,
        project_type: this.projectDetail.project_type,
        start_date: this.projectDetail.start_date ?? null,
        end_date: this.projectDetail.end_date ?? null,
        plans: this.projectDetail.plans.length > 0 ? this.projectDetail.plans : this.project.plans,
        customer_info: this.projectDetail.customer_info ? this.projectDetail.customer_info : this.project.customer_info,
        is_spot_type: this.projectDetail.is_spot_type,
        pm: this.projectDetail.pm,
        project_labo_payments: this.projectDetail.project_labo_payments.length > 0
          ? this.projectDetail.project_labo_payments
          : this.project.project_labo_payments,
        payment_histories: this.projectDetail.payment_histories.length > 0
          ? this.projectDetail.payment_histories
          : this.project.payment_histories,
        project_info_detail: this.projectDetail.project_info_detail,
        technologies: this.projectDetail.technologies.length > 0 ? this.projectDetail.technologies : [],
        description: this.projectDetail.description,
        project_info_detail_images: this.projectDetail.project_info_detail_images,
      };
    },
    async initial() {
      await this.$store.dispatch('projectManagement/getProjectDetail', this.id);
      await this.$store.dispatch('projectManagement/getCustomerList');
      const id = this.id;
      this.$store.dispatch("projectManagement/getContractHistory", {
        id,
        date: this.dateFormat,
      });
      this.getDefaultProject();
      this.getDateRange();
    },
    uploadImage() {
      if (this.project_info_images.length + this.project.project_info_detail_images.length === 5) {
        this.image_error = 'Chọn tối đa 5 ảnh';
      } else {
        document.getElementById('project_image').click();
      }
    },
    isTechnologySelected(value) {
      return this.project.project_info_detail.technology_list.some(item => item.id === value);
    },
    showCostHistory() {
      document.getElementById('cost_history').style.display = 'block';
    },
    setListImage(event) {
      this.image_error = null;
      if (!this.validateInputImage(event.target.files)) {
        return;
      }
      for (let i = 0; i < event.target.files.length; i++) {
        if (!this.project_info_images.includes(event.target.files[i])) {
          let file = event.target.files[i];
          this.project_info_images.push(file);
        }
      }
      this.getImagePreviews();
      document.getElementById("project_image").value = null
    },
    validateInputImage(files) {
      const maxFile = 5;
      const extensions = ['png', 'jpeg', 'jpg'];
      const maxSize = 25;
      if (files.length > maxFile || (this.project_info_images.length + files.length) > maxFile) {
        this.image_error = this.$t('project_management.kickoff.kickoff_input_image_amount_error_message');
        return false;

      } else {
        for (let i = 0; i < files.length; i++) {
          let file = files[i];
          let fileNameExt = file.name.split('.').pop();
          let fileSize = file.size / (1024 * 1024);

          if (!extensions.includes(fileNameExt.toLowerCase())) {
            this.image_error = this.$t('project_management.kickoff.kickoff_input_image_file_error_message');
          } else if (fileSize > maxSize) {
            this.image_error = this.$t('project_management.kickoff.kickoff_input_image_size_error_message');
          }

          if (this.image_error !== null) {
            return false;
          }
        }
      }

      return true;
    },
    removeImage(key) {
      this.project_info_images.splice(key, 1);
    },
    getImagePreviews() {
      for (let i = 0; i < this.project_info_images.length; i++) {
        if (/\.(jpe?g|png)$/i.test(this.project_info_images[i].name)) {
          if (this.isFileInstance(this.project_info_images[i])) {
            this.project_info_images[i].file_url = URL.createObjectURL(this.project_info_images[i]);
          }
        } else {
          this.project_info_images[i].file_url = document.getElementById('img-default').src;
        }
      }
      this.loadImages(this.project_info_images);
    },
    loadImages(files) {
      if (files.length > 0) {
        this.$root.$loading.start();
        for (let i = 0; i < files.length; i++) {
          const img = new Image();
          img.src = files[i].file_url;
          img.onload = () => {
            if (i + 1 === files.length) {
              this.$root.$loading.finish();
            }
          };
          img.onerror = () => {
            if (i + 1 === files.length) {
              this.$root.$loading.finish();
            }
          };
        }
      }
    },
    isFileInstance(file) {
      return file instanceof File;
    },
    removeOldImage(id, key) {
      this.project.project_info_detail_images.splice(key, 1);
      this.project_info_detail_images_remove.push(id);
    }
  },
};
</script>

<style lang="scss" scoped>
.c-body {
  background: #F9FAFC;
}

.project_detail {
  // Common CSS
  background: #FFFFFF;

  .pointer_none {
    pointer-events: none;
  }

  .empty_block {
    width: 31px;
    height: 31px;
  }

  .common_padding {
    padding: 20px 30px;
  }

  .common_input {
    background: #FFFFFF;
    border: 1px solid #CFCFCF;
    border-radius: 5px;
    padding: 10px;

    &:focus {
      color: #768192;
      background-color: #fff;
      border-color: #958bef;
      outline: 0;
    }
  }

  .common_icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .required {
    color: #F03D3E;
  }

  .text-align-center {
    text-align: center;
  }


  .common_table {
    @extend .common_padding;

    .ptable {
      --border: 1px solid #EFEFEF;
      border-radius: 10px;
      border-spacing: 0;
      border-collapse: separate;
      border: var(--border);
      border-top: 0;
      overflow: hidden;

      & th:not(:last-child),
      & td:not(:last-child) {
        border-right: var(--border);
      }

      & > thead > tr:not(:last-child) > th,
      & > thead > tr:not(:last-child) > td,
      & > tbody > tr:not(:last-child) > th,
      & > tbody > tr:not(:last-child) > td,
      & > tfoot > tr:not(:last-child) > th,
      & > tfoot > tr:not(:last-child) > td,
      & > tr:not(:last-child) > td,
      & > tr:not(:last-child) > th,
      & > thead:not(:last-child),
      & > tbody:not(:last-child),
      & > tfoot:not(:last-child) {
        border-bottom: var(--border);
      }

      &__thead {
        padding: 1em;
        background: #3488EB;
        border-radius: 10px 10px 0px 0px;

        th {
          @extend .text-align-center;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          color: #FFFFFF;
          border-bottom: 0 !important;
          border-right: 1px solid;
        }
      }

      &__tbody {
        padding: 1em;

        th {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #303C54;
          border: 1px solid #EFEFEF;
          vertical-align: baseline;
        }

        td {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #303C54;
          border: 1px solid #EFEFEF;
          vertical-align: baseline;
        }
      }

      .ptable_input_wrapper {
        width: 100%;
        position: relative;

        .ptable__input {
          @extend .common_input;
          width: 100%;
          height: 40px;
          min-width: 150px;
        }

        .ptable__icon {
          @extend .common_icon;
          position: absolute;
          right: 7px;
          top: 12px;
        }

        .ptable__percentage {
          position: absolute;
          right: 27px;
          top: 12px;
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          color: #303C54;
        }
      }
    }
  }

  .btn_add_wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 10px;

    .plus_icon {
      width: 31px;
      height: 31px;
      background: #F1F1F1;
      padding: 8px;
      border-radius: 50%;
      cursor: pointer;
    }

    .btn_add__title {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #303C54;
      margin-left: 10px;
      margin-bottom: 0;
      cursor: pointer;
    }

    .project_detail_input__label {
      width: 100%;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #303C54;
      margin-bottom: 8px;
    }

    .pro_info_add_image {
      box-sizing: border-box;
      display: inline-flex;
      padding: 6px;
      width: 116px;
      height: 32px;
      background: #F8F8F8;
      border: 1px solid #EDEDED;
      border-radius: 20px;

      .pro_info_image_upload {
        border: none;
      }
    }

    .pro_info_add_image:focus {
      outline: 0px;
    }
  }

  .project_img_wrapper {
    display: inline-grid;
  }

  .validation_error {
    color: #F03D3E;
    text-align: left;
    display: flex;
    align-items: center;
  }

  /deep/ .multiselect__tags {
    height: auto;
    vertical-align: middle;
    align-items: center;
    border: 1px solid #CFCFCF;

    &:focus {
      color: #768192;
      background-color: #fff;
      border-color: #958bef;
      outline: 0;
    }

    .multiselect__tag {
      margin-bottom: 0 !important;
    }

    .multiselect__placeholder {
      margin-bottom: 0 !important;
    }
  }

  /deep/ .mx-datepicker {
    width: 100% !important;
    height: 40px;

    .mx-input-wrapper {
      height: 100% !important;
      margin-right: 0;

      .mx-input {
        height: 100% !important;


        &:focus {
          color: #768192;
          background-color: #fff;
          border-color: #958bef;
          outline: 0;
        }

        &:hover {
          background-color: #fff;
          border-color: #958bef;
          outline: 0;
        }
      }

      .mx-icon-calendar {
        svg {
          color: black;
        }
      }

      @media screen and (min-width: 1024px) {
      }
    }
  }

  /deep/ .select2 {
    width: 100% !important;

    &-selection {
      border: 1px solid #CFCFCF !important;
      height: 40px !important;

      &__rendered {
        height: 100% !important;
        vertical-align: middle !important;
        display: flex !important;
        align-items: center !important;
      }

      &__arrow {
        height: 100% !important;
      }
    }
  }

  .project_detail_catalog {
    width: 100%;
    background: #EDEDED;
    padding: 13px 30px;

    &__name {
      margin: 0;
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      color: #303C54;
    }
  }

  .project_detail_form {
    @extend .common_padding;
    display: flex;
    //justify-content: space-between;

    .project_detail_input {
      flex: 1 1 50%;
      margin-right: 22px;

      &__label {
        width: 100%;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #303C54;
        margin-bottom: 8px;
      }

      &__input {
        @extend .common_input;
        width: 100%;
        height: 40px;
      }

      @media screen and (max-width: 1024px) {
        margin-right: 0;
      }

      .project_detail_textarea {
        width: 100%;
        box-sizing: border-box;
        height: 120px;
        left: 309px;
        top: 1315px;
        background: #FFFFFF;
        border: 1px solid #CFCFCF;
        border-radius: 5px;
        padding: 10px;

        &:focus {
          color: #768192;
          background-color: #fff;
          border-color: #958bef;
          outline: 0;
        }
      }
    }

    @media screen and (max-width: 1024px) {
      display: block;
    }
  }

  .vertical_align {
    vertical-align: middle !important;
  }

  .odd {
    background-color: #293462;
    text-align: center;
    vertical-align: middle !important;
  }

  .even {
    background-color: #1EBE71;
    text-align: center;
    vertical-align: middle !important;
  }

  .border_bottom {
    border-bottom: 1px solid #CFCFCF;
  }

  .pb_20 {
    padding-bottom: 20px;
  }

  .disabled {
    background: #F0F0F0 !important;
    border: 1px solid #CFCFCF !important;
    border-radius: 5px !important;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #303C54;
    pointer-events: none;
  }

  // CSS for each block
  .project_info_wrapper {
    .project_detail_form {
      flex-flow: wrap;

      .project_detail_input {
        flex: 1 1 30%;
        padding-right: 10px;

        .spot_icon_cost {
          margin-top: 16px;
        }

        #popover-target-1 {
          background: #ffffff;
          border: none;
          outline: none;
          margin-top: 15px;

          &:focus {
            outline: none;
            border: none;
            box-shadow: none;
          }
        }
      }

      .spot_detail_input {
        padding-right: 0px;
      }

      .project_detail_labo {
        width: 100%;
        margin-top: 10px;

        .project_detail_input {
          padding-right: 0;
        }

        &__container {
          display: flex;
          position: relative;
          margin-bottom: 10px;

          .project_detail_labo_icon_del {
            position: absolute;
            right: -10px;
            width: 37px;
            height: 148px;
            background: #F1F1F1;
            padding: 8px;
            border-radius: 10px;
            cursor: pointer;
            top: 10px;
          }
        }

        .project_mm_container {
          border-bottom: 1px solid #CFCFCF;
          padding-bottom: 20px;
        }

        .project_employee_detail,
        .project_time_cost {
          width: 98%;
          display: inline-flex;
          margin-top: 10px;
        }

        .project_employee_detail {
          .none_label {
            padding-bottom: 14px;
          }
        }
      }

      .project_detail_name {
        display: inline-flex;

        .project_detail_input {
          padding-right: 0px;
          margin: 0;
        }

        .project_detail_input_labo {
          height: 40px;
          padding-left: 10px;
        }

        #cost_history {
          width: 229px;
          overflow: scroll;
          height: 200px;

          .detail_history_contract {
            border-bottom: 1px;
          }
        }
      }
    }
  }

  .project_plan_wrapper {
    .ptable_wrapper {
      @extend .common_table;
      overflow: auto;

      .ptable__plan_name {
        min-width: 150px;
        font-weight: 700 !important;
      }

      .mx-input {
        min-width: 150px;
      }

      .ptable__tbody {
        .btn_add_wrapper {
          justify-content: center;
          vertical-align: middle;
          height: 100%;
          margin-top: 0;
          cursor: pointer;
        }

        .editabled {
          padding: 10px;
          border: none;
          width: 100%;
          pointer-events: none;
        }

        .ptable__input {
          pointer-events: auto;
          border: 1px solid #CFCFCF;
          border-radius: 5px;
        }
      }
    }

    @media screen and (max-width: 1024px) {
      overflow: scroll;
    }
  }

  .project_payment_wrapper {
    .ptable_wrapper {
      overflow: auto;
      @extend .common_table;

      th, td {
        vertical-align: middle;
        text-align: center;
        height: 46px;
      }

      .mx-input {
        min-width: 150px;
        text-align: center;
      }

      .ptable_input_wrapper {
        .ptable__input {
          text-align: center;
          pointer-events: auto;
        }
      }

      .ptable__tbody {
        .btn_add_wrapper {
          justify-content: center;
          cursor: pointer;
          margin-top: 0;
        }
      }
    }
  }

  .project_employee_wrapper {
    .project_detail_form_wrapper {
      padding: 20px 30px;

      .project_detail_form {
        padding: 0 0 27px 0;
        margin-bottom: 20px;
        border-bottom: 1px solid #CFCFCF;

        .date_range_wrapper {
          flex: 1 1 100%;

          .date_range_container {
            display: flex;
            margin-bottom: 10px;

            .empty_block {
              width: 31px;
              height: 31px;
            }
          }
        }
      }

      .project_info {
        border-bottom: none;
        padding: 0px;
        margin-bottom: 5px;
        margin-top: 10px;
      }

      .delete_button_wrapper {
        display: flex;
        align-items: baseline;

        .btn_add_wrapper {
          margin-top: 0;
          cursor: pointer;

          .plus_icon {
            width: 40px;
            height: 40px;
          }

          .empty_block {
            width: 40px;
            height: 40px;
            pointer-events: none;
          }
        }
      }

      .date_range_wrapper {
        padding-right: 30px;

        .delete_button_wrapper {
          margin-top: 30px;

          .plus_icon {
            width: 31px;
            height: 31px;
          }
        }
      }
    }
  }

  .btn_wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 10px 30px 10px 30px;

    .btn_submit {
      width: 172px;
      height: 49px;
      border-radius: 5px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      color: #fff;
      background: #118FA6;
      border: 1px solid #118FA6;
      margin-right: 20px;

      &:focus {
        outline: none;
      }
    }

    .btn_cancel {
      width: 172px;
      height: 49px;
      background: #FFFFFF;
      border: 1px solid #6E7A8B;
      border-radius: 5px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      color: #1F2D3D;

      &:focus {
        outline: none;
      }
    }
  }

  .w_100 {
    width: 100% !important;
  }

  .w_96 {
    width: 96% !important;
  }

  .w_99 {
    width: 99% !important;
  }


  .upload-image-list {
    padding-top: 10px;
    width: 100%;
    height: auto;
    display: flex;
  }

  .upload-image-list .file {
    width: fit-content;
    height: auto;
    margin: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5px 15px;
  }

  .upload-image-list .file .btn-delete {
    width: 50px;
    height: auto;
    color: #999;
    font-size: 10px;
    font-weight: 300;
    line-height: 12px;
    margin: 19px 0;
    padding: 0;
    float: right;
    transition: all .3s;
    border: none;
    outline: none;
  }

  .upload-image-list .file figure {
    width: 100px;
    height: 100px;
    background: #eee;
    border-radius: 3px;
    margin: 0;
    padding: 1px;
    display: block;
    float: left;
    overflow: hidden;
  }

  .upload-image-list .file figure img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .text-center {
    text-align: center;
  }
}
</style>
